import React from 'react';
import Service from './ConfGql';
import LocalizedString from './ConfText';

function at() {
  const urlParams = new URLSearchParams(window.location.search);
  const defaultTime = '2018-10-28T1:1:15.222-07:00';
  return (
    urlParams.get('at') || console.warn(`using ${defaultTime} as default for missing query param 'at'`) || defaultTime
  );
}

function deviceUuid() {
  const urlParams = new URLSearchParams(window.location.search);
  const defaultDeviceUuid = 'awair-omni_187';
  return (
    urlParams.get('deviceUuid') ||
    console.warn(`using ${defaultDeviceUuid} as default for missing query param 'deviceUuid'`) ||
    defaultDeviceUuid
  );
}
function temperatureUnit() {
  const urlParams = new URLSearchParams(window.location.search);
  const defaultTemperatureUnit = 'c';
  return (
    urlParams.get('temperatureUnit') ||
    console.warn(`using ${defaultTemperatureUnit} as default for missing query param 'temperatureUnit'`) ||
    temperatureUnit
  );
}

function darkMode() {
  const urlParams = new URLSearchParams(window.location.search);
  const defaultMode = false;
  return (
    urlParams.get('darkMode') ||
    console.warn(`using ${defaultMode} as default for missing query param 'darkMode'`) ||
    defaultMode
  );
}

let CONF = {};
CONF.queryParam = {};
CONF.queryParam.language = LocalizedString.language;
CONF.queryParam.at = at();
CONF.queryParam.deviceUuid = deviceUuid();
CONF.queryParam.darkMode = darkMode();
CONF.queryParam.temperatureUnit = temperatureUnit();
CONF.deviceType = CONF.queryParam.deviceUuid.split('_')[0];
CONF.deviceId = CONF.queryParam.deviceUuid.split('_')[1];
CONF.temperature = (degrees) => {
  switch (CONF.queryParam.temperatureUnit) {
    case 'f':
      return degrees * (9 / 5) + 32;
    case 'c':
      return degrees;
    default:
      return degrees;
  }
};
CONF.icon = {};
CONF.icon.DUST = {};
CONF.icon.DUST.name = 'Dust';
CONF.icon.DUST.svg = (color) => {
  return (
    <svg viewBox='0 0 73.91 73.91'>
      <g fill={color}>
        <path d='M37,0A37,37,0,1,0,73.91,37,37,37,0,0,0,37,0ZM47.84,37.68a10.37,10.37,0,0,1-.06,1.12l2.15,1a2.4,2.4,0,0,1,1.42-.29,1.88,1.88,0,0,1,1.35.82,1.86,1.86,0,0,1,.31.78A2.27,2.27,0,0,1,53,42a2,2,0,0,1-1.05,1.32,1.87,1.87,0,0,1-1.57,0,2.47,2.47,0,0,1-1.16-1.07,1.55,1.55,0,0,1-.17-.4l-1.71-.78A11.08,11.08,0,0,1,46,43.8L47.32,46a2.26,2.26,0,0,1,1.19.44,2,2,0,0,1,.78,1.4,2.21,2.21,0,0,1-.61,1.57A2.26,2.26,0,0,1,47.1,50a1.93,1.93,0,0,1-1.39-.78,2.4,2.4,0,0,1-.36-2.1l-1-1.53a10.94,10.94,0,0,1-3.33,2.15l.54,2.18a2.42,2.42,0,0,1,1,1.12,1.81,1.81,0,0,1,0,1.56,2,2,0,0,1-1.32,1.06,2.26,2.26,0,0,1-.89.06,1.93,1.93,0,0,1-.78-.32,1.83,1.83,0,0,1-.81-1.35,2.34,2.34,0,0,1,.34-1.52,1.37,1.37,0,0,1,.22-.3l-.46-1.86a10.83,10.83,0,0,1-1.9.18,10.51,10.51,0,0,1-2-.19l-.38,1.91a1.79,1.79,0,0,1,.2.26,2.47,2.47,0,0,1,.34,1.52,1.84,1.84,0,0,1-.82,1.35,1.87,1.87,0,0,1-.78.32,2.27,2.27,0,0,1-.89-.06,2,2,0,0,1-1.32-1.06,1.85,1.85,0,0,1,0-1.56,2.51,2.51,0,0,1,1.06-1.16l.42-2.16A11,11,0,0,1,30,46l-1.31,1.56a1.37,1.37,0,0,0,0,.19,2.31,2.31,0,0,1-.46,1.47,2,2,0,0,1-1.4.78,2.12,2.12,0,0,1-2.19-2.19,2,2,0,0,1,.78-1.4A2.31,2.31,0,0,1,26.87,46L27,46l1.37-1.63a10.91,10.91,0,0,1-1.62-2.91l-2,.77s0,0,0,.05a2.53,2.53,0,0,1-1.17,1.06,1.85,1.85,0,0,1-1.56,0A2,2,0,0,1,21,42a2.26,2.26,0,0,1-.06-.89,1.87,1.87,0,0,1,.32-.78,1.84,1.84,0,0,1,1.35-.82,2.47,2.47,0,0,1,1.52.34,1.24,1.24,0,0,1,.18.14l1.92-.75a11,11,0,0,1-.12-1.53,10.7,10.7,0,0,1,.19-2l-1.93-.34a2.07,2.07,0,0,1-.24.17,2.34,2.34,0,0,1-1.52.34,1.83,1.83,0,0,1-1.35-.81,1.93,1.93,0,0,1-.32-.78A2.26,2.26,0,0,1,21,33.4,2,2,0,0,1,22,32.08a1.85,1.85,0,0,1,1.56,0,2.53,2.53,0,0,1,1.17,1.06v0l2.16.38a10.56,10.56,0,0,1,1.19-2.13l-1.31-2a2.27,2.27,0,0,1-1.39-.46,1.93,1.93,0,0,1-.78-1.39A2.26,2.26,0,0,1,25.24,26a2.21,2.21,0,0,1,1.57-.61,2,2,0,0,1,1.4.78,2.24,2.24,0,0,1,.45,1.47,1.84,1.84,0,0,1,0,.41l1.06,1.6a10.66,10.66,0,0,1,3.46-2.11l-.65-2-.12-.05a2.51,2.51,0,0,1-1.06-1.16,1.87,1.87,0,0,1,0-1.57,2,2,0,0,1,1.32-1,2.27,2.27,0,0,1,.89-.06,1.86,1.86,0,0,1,.78.31,1.88,1.88,0,0,1,.82,1.35,2.5,2.5,0,0,1-.34,1.53,1.34,1.34,0,0,1-.11.14l.65,2A10.47,10.47,0,0,1,37,26.8a11.32,11.32,0,0,1,1.43.1l.76-2-.06-.07a2.4,2.4,0,0,1-.33-1.52,1.93,1.93,0,0,1,1.59-1.67,2.26,2.26,0,0,1,.89.06,2,2,0,0,1,1.32,1,1.87,1.87,0,0,1,0,1.57,2.46,2.46,0,0,1-1.06,1.16l-.2.09-.71,1.89a11,11,0,0,1,3.07,1.7l1.55-1.56a2.28,2.28,0,0,1,.46-1.46,1.93,1.93,0,0,1,1.39-.78,2.09,2.09,0,0,1,2.19,2.19,1.93,1.93,0,0,1-.78,1.39,2.19,2.19,0,0,1-1.47.46,1.84,1.84,0,0,1-.33,0l-1.37,1.38a11,11,0,0,1,1.94,3.51L49,33.56a1.63,1.63,0,0,1,.18-.46A2.51,2.51,0,0,1,50.33,32a1.87,1.87,0,0,1,1.57,0A2,2,0,0,1,53,33.4a2.26,2.26,0,0,1,.06.89,1.91,1.91,0,0,1-.31.78,1.87,1.87,0,0,1-1.35.81A2.4,2.4,0,0,1,50,35.63l-2.2.88A11.46,11.46,0,0,1,47.84,37.68Z' />
      </g>
    </svg>
  );
};
CONF.icon.PM10 = {};
CONF.icon.PM10.name = 'Dust (PM10)';
CONF.icon.PM10.svg = CONF.icon.DUST.svg;
CONF.icon.PM25 = {};
CONF.icon.PM25.name = 'Fine Dust (PM2.5)';
CONF.icon.PM25.svg = CONF.icon.DUST.svg;
CONF.icon.VOC = {};
CONF.icon.VOC.name = 'Chemicals';
CONF.icon.VOC.svg = (color) => {
  return (
    <svg viewBox='0 0 73.91 73.91'>
      <g fill={color}>
        <path d='M37,0A37,37,0,1,0,73.91,37,37,37,0,0,0,37,0Zm9.26,22.2a3.62,3.62,0,1,1-3.62,3.62A3.62,3.62,0,0,1,46.22,22.2Zm-23.07,18a3.62,3.62,0,1,1,3.62-3.62A3.63,3.63,0,0,1,23.15,40.2Zm3.36-14.27a2,2,0,1,1,2,2A2,2,0,0,1,26.51,25.93Zm5.42,23.92a2,2,0,0,1-2.76-.31,2,2,0,1,1,3.08-2.45A2,2,0,0,1,31.93,49.85Zm-.24-8a7.45,7.45,0,1,1,10.53,0A7.44,7.44,0,0,1,31.69,41.85ZM44.26,51.94a3.63,3.63,0,1,1,3.62-3.63A3.63,3.63,0,0,1,44.26,51.94Zm5.12-11.87a2,2,0,1,1,2-2A2,2,0,0,1,49.38,40.07Z' />
        <path d='M40.92,32.62a5.6,5.6,0,1,0,0,7.92A5.59,5.59,0,0,0,40.92,32.62Z' />
      </g>
    </svg>
  );
};
CONF.icon.CO2 = {};
CONF.icon.CO2.name = 'CO₂';
CONF.icon.CO2.svg = (color) => {
  return (
    <svg viewBox='0 0 73.91 73.91'>
      <g fill={color}>
        <path d='M37,0A37,37,0,1,0,73.91,37,37,37,0,0,0,37,0Zm1.17,22.17s3.95.24,4.91,2.73a4.54,4.54,0,0,1,2.05-.56,6.52,6.52,0,0,1,5,7.47l-.32.8A11.38,11.38,0,0,0,46,31.35l-.29-.6a5.41,5.41,0,0,0-5.08-3.29l-.48,0a6.92,6.92,0,0,0-4.51-1.94h0a5.1,5.1,0,0,0-2.21.51A4.49,4.49,0,0,1,38.13,22.17Zm-9,5.78s2.57,0,3.08.88A4.11,4.11,0,0,1,35.56,27a5.75,5.75,0,0,1,4.11,2,4.27,4.27,0,0,1,4.83,2.42,10.38,10.38,0,0,0-5.57,3.19,9.36,9.36,0,0,0-4.51-1.36c-2.87,0-5.27,2-6.3,2.94a12.45,12.45,0,0,0-1.4-.06h-.8A8,8,0,0,0,23,37l0-.28S22.59,28,29.11,28ZM46.7,50.11H25.45s-5.2-.4-5.2-6.26S26,37.59,26,37.59a10.35,10.35,0,0,1,2.56.16s2.64-3,5.86-3c0,0,3.08.08,4.69,1.84,0,0,2.71-3.77,6.59-3.77,0,0,8,.8,8,8.67S46.7,50.11,46.7,50.11Z' />
      </g>
    </svg>
  );
};
CONF.icon.HUMID = {};
CONF.icon.HUMID.name = 'Humidity';
CONF.icon.HUMID.svg = (color) => {
  return (
    <svg viewBox='0 0 73.91 73.91'>
      <g fill={color}>
        <path d='M37,0A37,37,0,1,0,73.91,37,37,37,0,0,0,37,0Zm7.41,30h6.2v1.84h-6.2ZM35.73,53.16A9.72,9.72,0,0,1,26,45.4a10,10,0,0,1,0-4.28,10.16,10.16,0,0,1,.85-2.33L29,34.39l6.24-12.65,6.19,12.55,2.2,4.5a10,10,0,0,1,.85,2.35,10.31,10.31,0,0,1,.24,2.17A9.7,9.7,0,0,1,35.73,53.16ZM47,35.56h6.19V37.4H47Zm7.08,12.9h-6.2V46.61h6.2Zm1.77-5.53h-6.2V41.09h6.2Z' />
      </g>
    </svg>
  );
};
CONF.icon.TEMP = {};
CONF.icon.TEMP.name = 'Temperature';
CONF.icon.TEMP.svg = (color) => {
  return (
    <svg viewBox='0 0 73.91 73.91'>
      <g fill={color}>
        <path d='M37,0A37,37,0,1,0,73.91,37,37,37,0,0,0,37,0Zm0,54a5.49,5.49,0,0,1-3.24-9.94V24.64a3.24,3.24,0,0,1,6.47,0V27H37.1v1.44h3.09v2.68H37.1v1.43h3.09v2.68H37.1v1.44h3.09v2.67H37.1v1.44h3.09v3.28A5.49,5.49,0,0,1,37,54Z' />
      </g>
    </svg>
  );
};
CONF.icon.insight = {};
CONF.icon.insight.svg = () => (
  <svg viewBox='0 0 32 32'>
    <defs>
      <style>
        {`
					.icon-insight-cls-1,.icon-insight-cls-7,.icon-insight-cls-8{
						fill:none;
					}
					.icon-insight-cls-2{
						fill: #27B4EB;
					}
					.icon-insight-cls-3{
						fill:#fff;
					}
					.icon-insight-cls-4{
						clip-path:url(#icon-insight-clip-path);
					}
					.icon-insight-cls-5{
						clip-path:url(#icon-insight-clip-path-2);
					}
					.icon-insight-cls-6{
						clip-path:url(#icon-insight-clip-path-3);
					}
					.icon-insight-cls-7{
						stroke:#000;
						opacity:0.03;
					}
					.icon-insight-cls-7,.icon-insight-cls-8{
						stroke-miterlimit:10;
					}
					.icon-insight-cls-8{
						stroke:#fff;
					}
					.icon-insight-cls-9{
						clip-path:url(#icon-insight-clip-path-4);
					}
					.icon-insight-cls-10{
						clip-path:url(#icon-insight-clip-path-5);
					}
					.icon-insight-cls-11{
						clip-path:url(#icon-insight-clip-path-6);
					}
					.icon-insight-cls-12{
						clip-path:url(#icon-insight-clip-path-8);
					}
					`}
      </style>
      <clipPath id='icon-insight-clip-path'>
        <circle className='icon-insight-cls-1' cx='16' cy='16' r='15.5' />
      </clipPath>
      <clipPath id='icon-insight-clip-path-2'>
        <circle className='icon-insight-cls-2' cx='16' cy='16' r='15.5' />
      </clipPath>
      <clipPath id='icon-insight-clip-path-3'>
        <rect className='icon-insight-cls-1' x='0.5' y='0.5' width='31' height='31' />
      </clipPath>
      <clipPath id='icon-insight-clip-path-4'>
        <circle className='icon-insight-cls-3' cx='7.75' cy='20.75' r='1.25' />
      </clipPath>
      <clipPath id='icon-insight-clip-path-5'>
        <circle className='icon-insight-cls-1' cx='12.25' cy='14.25' r='1.75' />
      </clipPath>
      <clipPath id='icon-insight-clip-path-6'>
        <circle className='icon-insight-cls-1' cx='17' cy='18.5' r='1.5' />
      </clipPath>
      <clipPath id='icon-insight-clip-path-8'>
        <circle className='icon-insight-cls-1' cx='22.5' cy='10.5' r='2' />
      </clipPath>
    </defs>
    <title>ventilation icon</title>
    <g id='icon-insight-Layer_2' data-name='Layer 2'>
      <g id='icon-insight-Layer_1-2' data-name='Layer 1'>
        <circle className='icon-insight-cls-2' cx='16' cy='16' r='15.5' />
        <g className='icon-insight-cls-5'>
          <g className='icon-insight-cls-6'>
            <circle className='icon-insight-cls-7' cx='16' cy='16' r='15.5' />
          </g>
        </g>
        <polyline className='icon-insight-cls-8' points='7.75 20.75 12.25 14.25 17 18.5 22.5 10.5' />
        <circle className='icon-insight-cls-3' cx='7.75' cy='20.75' r='1.25' />
        <g className='icon-insight-cls-10'>
          <rect className='icon-insight-cls-3' x='8' y='10' width='8.5' height='8.5' />
        </g>
        <g className='icon-insight-cls-11'>
          <g className='icon-insight-cls-6'>
            <rect className='icon-insight-cls-3' x='13' y='14.5' width='8' height='8' />
          </g>
        </g>
        <g className='icon-insight-cls-12'>
          <g className='icon-insight-cls-6'>
            <rect className='icon-insight-cls-3' x='18' y='6' width='9' height='9' />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
CONF.icon.share = {};
CONF.icon.share.svg = () => {
  return (
    <svg viewBox='0 0 40.17 29.86'>
      <defs>
        <style>
          {`
						.icon-share-cls-1{
							fill:none;
							stroke:#9b9b9b;
							stroke-miterlimit:10;
							stroke-width:1.5px;
						}
						`}
        </style>
      </defs>
      <title>share</title>
      <path
        class='.icon-share-cls-1'
        d='M38.87,13,22.54,1.45v7l-2.49,0c-1.49,0-9.2.28-14.41,5.81C2.69,17.41,1.1,21.66.87,27c2.7-4.49,7.85-9.63,17.33-9.63.9,0,4.34.21,4.34.21v7Z'
      />
    </svg>
  );
};
CONF.icon.like = {};
CONF.icon.like.svg = () => {
  return (
    <svg viewBox='0 0 40.1 37.42'>
      <defs>
        <style>
          {`
						.icon-like-cls-1{
							fill:none;
							stroke:#9b9b9b;
							stroke-width:1.5px;
						}
						`}
        </style>
      </defs>
      <title>like</title>
      <path
        id='Heart'
        class='.icon-like-cls-1'
        d='M20.05,36.26,3.51,16.72c-2-2.71-2.76-4.54-2.76-7C.75,5,4.13.79,9,.75c4,0,8.58,4,11,7.07,2.39-2.95,7-7.07,11-7.07,4.76,0,8.27,4.25,8.27,8.92A10.29,10.29,0,0,1,36.6,16.8Z'
      />
    </svg>
  );
};
CONF.icon.SCORE = {};
CONF.icon.SCORE.svg = CONF.icon.insight.svg;
CONF.icon.SCORE_SECONDS = {};
CONF.icon.SCORE_SECONDS.svg = CONF.icon.insight.svg;
CONF.icon.doubleUpArrow = {};
CONF.icon.doubleUpArrow.svg = (color) => {
  return (
    <svg viewBox='0 0 10 7.3'>
      <g fill={color}>
        <polygon points='5.01 2.38 0 7.3 10 7.3 5.01 2.38' />
        <polygon points='5.01 1.37 8.61 4.92 10 4.92 5.01 0 0 4.92 1.4 4.92 5.01 1.37' />
      </g>
    </svg>
  );
};
CONF.icon.upArrow = {};
CONF.icon.upArrow.svg = (color) => {
  return (
    <svg viewBox='0 0 10 6'>
      <g fill={color}>
        <polygon points='5.01 0 10 6 0 6 5.01 0' />
      </g>
    </svg>
  );
};
CONF.icon.dash = {};
CONF.icon.dash.svg = (color) => {
  return (
    <svg viewBox='0 0 10 1'>
      <g fill={color}>
        <rect width='10' height='1' />
      </g>
    </svg>
  );
};
CONF.icon.downArrow = {};
CONF.icon.downArrow.svg = (color) => {
  return (
    <svg viewBox='0 0 10 6'>
      <g fill={color}>
        <polygon points='4.99 6 0 0 10 0 4.99 6' />
      </g>
    </svg>
  );
};
CONF.icon.doubleDownArrow = {};
CONF.icon.doubleDownArrow.svg = (color) => {
  return (
    <svg viewBox='0 0 10 7.3'>
      <g fill={color}>
        <polygon points='10 0 0 0 4.99 4.92 10 0' />
        <polygon points='4.99 5.93 1.39 2.38 0 2.38 4.99 7.3 10 2.38 8.6 2.38 4.99 5.93' />
      </g>
    </svg>
  );
};
CONF.verdict = {};
CONF.verdict.GOOD = {};
CONF.verdict.GOOD.color = 'var(--green)';
CONF.verdict.FAIR = {};
CONF.verdict.FAIR.color = 'var(--amber)';
CONF.verdict.POOR = {};
CONF.verdict.POOR.color = 'var(--red)';
CONF.color = (string) => `var(--${string.toLowerCase()})`;
CONF.solutionTipIconColor = (string) => `var(--solution-tip-icon-color-${string.toLowerCase().replace('_', '-')})`;
CONF.iconFromMetric = (metric, color) => CONF['icon'][metric]['svg'](color ? color : 'var(--light-blue)');
CONF.iconFromComponent = (component, color) => {
  switch (component) {
    case 'TEMP':
      return CONF.iconFromMetric('TEMP', color);
    case 'HUMID':
      return CONF.iconFromMetric('HUMID', color);
    case 'CO2':
      return CONF.iconFromMetric('CO2', color);
    case 'VOC':
      return CONF.iconFromMetric('VOC', color);
    case 'DUST':
      return CONF.iconFromMetric('DUST', color);
    case 'PM25':
      return CONF.iconFromMetric('PM25', color);
    case 'PM10':
      return CONF.iconFromMetric('PM10', color);
    default:
      return CONF['icon']['insight']['svg']('var(--purple)');
  }
};
CONF.dimensionUnitFromKind = (dimensionKind, plural) => {
  switch (dimensionKind) {
    case 'TEMP':
      switch (plural) {
        case false:
          switch (CONF.queryParam.temperatureUnit) {
            case 'c':
              return CONF.text['degree Celsius']();
            case 'f':
              return CONF.text['degree Fahrenheit']();
            default:
              return CONF.text['degrees Celsius']();
          }
        default:
          switch (CONF.queryParam.temperatureUnit) {
            case 'c':
              return CONF.text['degrees Celsius']();
            case 'f':
              return CONF.text['degrees Fahrenheit']();
            default:
              return CONF.text['degrees Celsius']();
          }
      }
    case 'HUMID':
      return CONF.text['%RH']();
    case 'CO2':
      return CONF.text['ppm']();
    case 'VOC':
      return CONF.text['ppb']();
    case 'DUST':
      return CONF.text['µg/m³']();
    case 'PM25':
      return CONF.text['µg/m³']();
    case 'PM10':
      return CONF.text['µg/m³']();
    case 'SCORE':
      switch (plural) {
        case false:
          return CONF.text['point']();
        default:
          return CONF.text['points']();
      }
    default:
      return '';
  }
};
CONF.formattedDimensionKind = (dimensionKind) => {
  switch (dimensionKind) {
    case 'TEMP':
      return CONF.text['temperature']();
    case 'HUMID':
      return CONF.text['humidity']();
    case 'CO2':
      return CONF.text['CO₂']();
    case 'VOC':
      return CONF.text['chemicals']();
    case 'DUST':
      return CONF.text['dust']();
    case 'PM25':
      return CONF.text['PM2.5']();
    case 'PM10':
      return CONF.text['PM10']();
    case 'SCORE':
      return CONF.text['Awair Score']();
    default:
      return '';
  }
};
CONF.formattedDimensionKindPlurality = (dimensionKind) => {
  switch (dimensionKind) {
    case 'TEMP':
      return CONF.text['is']();
    case 'HUMID':
      return CONF.text['is']();
    case 'CO2':
      return CONF.text['is']();
    case 'VOC':
      return CONF.text['are']();
    case 'DUST':
      return CONF.text['is']();
    case 'PM25':
      return CONF.text['is']();
    case 'PM10':
      return CONF.text['is']();
    case 'SCORE':
      return CONF.text['is']();
    default:
      return CONF.text['is']();
  }
};
CONF.deepLinkComponentNameFromDimensionKind = (dimensionKind) => {
  switch (dimensionKind) {
    case 'TEMP':
      return 'temp';
    case 'HUMID':
      return 'humid';
    case 'CO2':
      return 'co2';
    case 'VOC':
      return 'voc';
    case 'DUST':
      return 'dust';
    case 'PM25':
      return 'pm25';
    case 'PM10':
      return 'pm10';
    case 'SCORE':
      return 'score';
    default:
      return 'unassigned';
  }
};
CONF.text = LocalizedString;
CONF.service = Service;
export default CONF;
